import {log} from "@dp-instant/utils";
import {Action} from "@dp-instant/core";
import {inject, injectable} from "inversify";
import {TypesGame} from "@game/TypesGame";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesSocial} from "@dp-instant/interfaces";
import {ISocial} from "@dp-instant/social";

@injectable()
export class TournamentShareAction extends Action<any, boolean> {
    @inject(TypesGame.model)
    private readonly model: GameModel;

    @inject(TypesSocial.model)
    private readonly social: ISocial;

    async execute(): Promise<boolean> {
        if (this.social.socialPlatform !== "fb") {
            return false;
        }

        const continent = this.model.currentContinent;

        return await window.FBInstant.tournament
            .shareAsync({
                score: continent.getTotalScore(),
                data: continent.getHistory()
            })
            .then(() => true)
            //@ts-ignore
            .catch(err => {
                log.warn("FBInstant.tournament.createAsync", err);
                return false;
            });
    }
}
